// DATEPICKER
export const datePlaceholder = '__ /__ /__ __';
